import { array, object, string } from 'yup';
import { isValid } from 'date-fns';
import { injectable } from 'inversify';

import EpgService from '../EpgService';
import type { PlaylistItem } from '../../../types/playlist';
import type { EpgProgram } from '../../../types/epg';
import { getDataOrThrow } from '../../utils/api';
import { logDev } from '../../utils/common';


const AUTHENTICATION_HEADER = 'API-KEY';

const jwEpgProgramSchema = object().shape({
  id: string().nullable().notRequired(),
  title: string().required(),
  startTime: string()
    .required()
    .test((value) => (value ? isValid(new Date(value)) : false)),
  endTime: string()
    .required()
    .test((value) => (value ? isValid(new Date(value)) : false)),
  chapterPointCustomProperties: array().of(
    object().shape({
      key: string().required(),
      value: string()
        .nullable()
        .notRequired() // Makes the `value` field optional
        .test(
          'is-string-or-empty',
          'Value must be a string if provided',
          (value: unknown) => value === undefined || value === null || typeof value === 'string',
        ),
    }),
  ),
});

@injectable()
export default class JWEpgService extends EpgService {
  transformProgram = async (data: unknown, index: number): Promise<EpgProgram> => {
    const program = await jwEpgProgramSchema.validate(data);
    const image = program.chapterPointCustomProperties?.find((item) => item.key === 'image')?.value || undefined;

    return {
      id: `${index + Date.now() + program.startTime}`,
      title: program.title,
      startTime: program.startTime,
      endTime: program.endTime,
      cardImage: image,
      backgroundImage: image,
      description: program.chapterPointCustomProperties?.find((item) => item.key === 'description')?.value || undefined,
    };
  };

  fetchSchedule = async (item: PlaylistItem) => {
    if (!item.scheduleUrl) {
      logDev('Tried requesting a schedule for an item with missing scheduleUrl', item);
      return undefined;
    }

    const headers = new Headers();

    // Add authentication token when defined
    if (item.scheduleToken) {
      headers.set(AUTHENTICATION_HEADER, item.scheduleToken);
    }

    // const now = new Date();
    // const localTodayDateString = now.toLocaleDateString('en-CA');

    try {
      
      const response = await fetch(`${item.scheduleUrl}?nocache=${new Date().getTime()}`, {
        headers,
      });

      const data = await getDataOrThrow(response);
  

      // const result = data.filter((entry: any) => {
      //   const localStart = new Date(entry.startTime).toLocaleDateString('en-CA');
      //   const localEnd = new Date(entry.endTime).toLocaleDateString('en-CA');

      //   return localStart === localTodayDateString || localEnd === localTodayDateString;
      // });

      return data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        logDev(`Fetch failed for EPG schedule: '${item.scheduleUrl}'`, error);
      }
    }
  };
}
